// extracted by mini-css-extract-plugin
module.exports = {"heroBannerShopTitle":"HeroBannerShopTitle_heroBannerShopTitle__NHiYP","inverse":"HeroBannerShopTitle_inverse__aQztv"};